import loadable from "@loadable/component";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  fetchPendingItem,
  getIntegrationDetails,
  getOnCallLeadApi,
  storeAgentEventsOnCloud,
  storeEventsOnCloud,
} from "../api/dashboard";
import { getNotificationCount } from "../api/notifications";
import { getUserProfile, postPunchInOut } from "../api/profile";
import ProfileContainer from "../containers/ProfileContainer";
import adminFirebase from "../utils/adminFirebase";
import ModalRightPanel from "./common/modal/ModalRightPanel";
import { ModalControl } from "./common/modal/ModalRoot";
import "./Header.scss";
import Draggable from "./common/core/Draggable";
import { slashRtc } from "../api/callingDashboard";
import ModalPanel from "./common/modal/ModalPanel";
import LeadSearchModal from "./LeadSearchModal";
import { NA } from "../utils/constant";
const NotificationContainer = loadable(() =>
  import("../containers/NotificationContainer")
);
const Button = loadable(() => import("./common/Button"));
const Toast = loadable(() => import("./common/Toasts/Toast"));

const WorkLog = loadable(() =>
  import("../modules/WorkLogContainer/WorkLog.js")
);

function Header(props) {
  const [title, settile] = useState("NoBrokerHood Leads");
  const [loading, setloading] = useState(false);
  const label = props.universalLabels ? props.universalLabels : {};
  const [incomingNumber, setIncomingNumber] = useState(null);
  const [showIncomingCallFilter, setshowIncomingCallFilter] = useState(false);
  const [itemsCount, setItemsCount] = useState({});
  const incomingCallFilter =
    localStorage.getItem("incomingCallFilter") === "true";
  const toastRef = useRef();
  let attendance = props.profile?.attendance;
  let capabilities = props.profile?.uiCapabilities.map((val) => {
    return val.name;
  });

  const displayTicketManagement = capabilities?.includes("ticket_management");
  const displayMyApprovals = capabilities?.includes("my_approvals");
  const displayLeadService = capabilities?.includes("hood_service_lead");
  const workLogAutoOpen =
    props.profile?.capabilities &&
    props.profile?.capabilities?.includes("ROLE_ACCESS_DAILY_TIMESHEET");
  const profileRole = props.profile?.resource?.resourceJobRole?.roleCode;
  const isSocial =
    label?.SOCIAL_TICKETS && label?.SOCIAL_TICKETS !== "NA" ? true : false;

  const socialDashboardPathName = isSocial
    ? "/social-dashboard"
    : "/my-dashboard";
  const isDashboardLocked = props?.profile?.resource?.isDashboardLocked;
  const hideForM3M = props?.profile?.username
    ?.trim()
    ?.toLowerCase()
    ?.includes("@mworthfms.com");
  const navList = [
    !hideForM3M && {
      label: "Home",
      active: props.history?.location?.pathname === socialDashboardPathName,
      path: socialDashboardPathName,
    },
    label?.SOCIAL_TICKETS !== "NA" && {
      label: "Social Tickets",
      active: props.history?.location?.pathname === "/social-tickets",
      path: "/social-tickets",
    },
    !hideForM3M && {
      label: "Meetings",
      active: props.history?.location?.pathname === "/meetings",
      path: "/meetings",
      count: itemsCount?.meetings,
    },
    !hideForM3M && {
      label: "Tasks",
      active: props.history?.location?.pathname === "/tasks",
      path: "/tasks",
      count: itemsCount?.tasks,
    },
    ((label?.SHOW_JOBS_FOR_ADVOCATE || "Show Jobs Partner") !== NA ||
      profileRole !== "advocate") &&
      displayLeadService &&
      !hideForM3M && {
        label: "Jobs",
        active: props.history?.location?.pathname === "/jobs",
        path: "/jobs",
        count: itemsCount?.jobs,
      },
    displayTicketManagement &&
      !hideForM3M && {
        label: "Tickets",
        active: props.history.location.pathname === "/tickets",
        path: "/tickets",
        count: itemsCount?.tickets,
      },
    displayMyApprovals &&
      !hideForM3M && {
        label: "Approvals",
        active: props.history.location.pathname === "/my-approval",
        path: "/my-approval",
        count: itemsCount?.approvals,
      },
  ];
  useEffect(() => {
    setshowIncomingCallFilter(incomingCallFilter);
  }, [incomingCallFilter]);

  useEffect(() => {
    if (
      !adminFirebase.isAdminFirebaseInitialized &&
      props.appConfiguration?.firebaseUrl
    ) {
      adminFirebase.initalize(props.appConfiguration?.firebaseUrl);
    }
  }, [props.appConfiguration?.firebaseUrl]);

  const getOnCallLeadFn = async (data) => {
    const jsonData = {
      "contactFilter.primaryPhoneNumber": data?.phoneNumber,
      leadName: data?.leadName,
      "contactFilter.primaryEmailAddress": data?.emailAddress,
      leadRefId: data?.leadRefId,
      active: "true,false",
    };
    const serviceLead =
      props.history.location.pathname === "/lead-service" ? true : false;
    setloading(true);
    const result = await getOnCallLeadApi(jsonData, serviceLead);
    setloading(false);
    if (result?.status === 1) {
      props.update({ dashboard: result.data });
      if (result?.data?.content?.length === 0) {
        props.openModal(onCallLeadSearchModal(data));
      } else {
        props.closeModal();
      }
    }
  };

  const fetchPendingItemCall = async () => {
    const result = await fetchPendingItem();
    if (result?.status === 1) {
      setItemsCount(result?.data);
    }
  };
  useEffect(() => {
    if (
      props?.appConfiguration?.callEventUrl &&
      props.profile?.resource?.businessUnit?.id
    ) {
      window.addEventListener("message", (event) => {
        if (
          event?.data?.callInfo &&
          event?.data?.callInfo?.modeOfCalling === "Inbound"
        ) {
          if (event?.data?.eventInfo?.type === "callEnd") {
            setIncomingNumber(null);
            setshowIncomingCallFilter(false);
            localStorage.setItem("incomingCallFilter", false);
          } else if (event?.data?.eventInfo?.type === "callStart") {
            setIncomingNumber(event?.data?.callInfo?.customerNumber);
            localStorage.setItem("incomingCallFilter", true);
            setshowIncomingCallFilter(true);
          }
        }
        if (
          event?.data?.eventInfo &&
          props.profile &&
          props?.appConfiguration?.callEventUrl &&
          props.profile?.resource?.businessUnit?.id
        ) {
          if (
            event?.data?.eventInfo?.type === "callStart" ||
            event?.data?.eventInfo?.type === "callEnd" ||
            event?.data?.eventInfo?.type === "callOriginate" ||
            event?.data?.eventInfo?.type === "callRingingWithEarlyMedia" ||
            event?.data?.eventInfo?.type === "callAnswered" ||
            event?.data?.eventInfo?.type === "missedCall"
          ) {
            storeEventsOnCloud(
              props.appConfiguration?.callEventUrl,
              event?.data,
              props.profile?.resource?.businessUnit?.id
            );
          } else if (event?.data?.eventInfo?.type === "userOnline") {
            let params = {};
            params.data = JSON.stringify(event?.data);
            params.agentId = props.profile?.resource?.id;
            params.bussinessId = props.profile?.resource?.businessUnit?.id;
            storeAgentEventsOnCloud(
              props.appConfiguration?.callEventUrl,
              params
            );
          }
        }
      });
    }
    return () => {
      window.removeEventListener("message", (data) => {
        console.log(data);
      });
    };
  }, [props?.appConfiguration?.callEventUrl]);

  useEffect(() => {
    if (props.history) {
      if (
        props.history.location.pathname === "/home" ||
        props.history.location.pathname === "/"
      ) {
        settile(
          label?.SALES_LEAD_HEADER
            ? label?.SALES_LEAD_HEADER
            : "SALES_LEAD_HEADER"
        );
      } else if (props.history.location.pathname === "/lead-service") {
        settile(
          label?.SERVICE_LEAD_HEADER
            ? label?.SERVICE_LEAD_HEADER
            : "SERVICE_LEAD_HEADER"
        );
      } else if (props.history.location.pathname === "/sales-loan") {
        settile(
          label?.SALES_LOAN_HEADER
            ? label?.SALES_LOAN_HEADER
            : "SALES_LOAN_HEADER"
        );
      } else if (props.history.location.pathname === "/resource") {
        settile(
          label?.RESOURCES_HEADER ? label?.RESOURCES_HEADER : "RESOURCES_HEADER"
        );
      } else if (props.history.location.pathname === "/tasks") {
        settile("My Tasks");
      } else if (props.history.location.pathname === "/meetings") {
        settile("My Meetings");
      } else if (props.history.location.pathname === "/jobs") {
        settile("My Jobs");
      } else if (props.history.location.pathname === "/job-tickets") {
        settile("Tickets");
      } else if (props.history.location.pathname == "/lead-import") {
        settile(
          label?.DATA_IMPORT_HEADER
            ? label?.DATA_IMPORT_HEADER
            : "DATA_IMPORT_HEADER"
        );
      } else if (props.history.location.pathname == "/job-role") {
        settile(
          label?.DUTY_ROLE_HEADER ? label?.DUTY_ROLE_HEADER : "DUTY_ROLE_HEADER"
        );
      } else if (props.history.location.pathname == "/manage-attribute") {
        settile(
          label?.MANAGE_ATTRIBUTE_HEADER
            ? label?.MANAGE_ATTRIBUTE_HEADER
            : "MANAGE_ATTRIBUTE_HEADER"
        );
      } else if (props.history.location.pathname == "/lov-setup") {
        settile(
          label?.LOV_SETUP_HEADER ? label?.LOV_SETUP_HEADER : "LOV_SETUP_HEADER"
        );
      } else if (props.history.location.pathname == "/location") {
        settile("Society Location");
      } else if (
        props.history.location.pathname == "/notification-management"
      ) {
        settile(
          label?.MANAGE_NOTIFICATION_HEADER
            ? label?.MANAGE_NOTIFICATION_HEADER
            : "MANAGE_NOTIFICATION_HEADER"
        );
      } else if (props.history.location.pathname == "/report-management") {
        settile(
          label?.MANAGE_REPORT_HEADER
            ? label?.MANAGE_REPORT_HEADER
            : "MANAGE_REPORT_HEADER"
        );
      } else if (props.history.location.pathname == "/document-management") {
        settile(
          label?.MANAGE_DOCUMENTS_HEADER
            ? label?.MANAGE_DOCUMENTS_HEADER
            : "MANAGE_DOCUMENTS_HEADER"
        );
      } else if (
        props.history.location.pathname == "/service-feature-management"
      ) {
        settile(
          label?.SERVICE_PRODUCTS_HEADER
            ? label?.SERVICE_PRODUCTS_HEADER
            : "SERVICE_PRODUCTS_HEADER"
        );
      } else if (props.history.location.pathname == "/brands-and-campaigns") {
        settile("NoBrokerHood Brands & Campaigns");
      } else if (props.history.location.pathname == "/calling-dashboard") {
        settile(
          label?.CALLING_DASHBOARD_HEADER
            ? label?.CALLING_DASHBOARD_HEADER
            : "CALLING_DASHBOARD_HEADER"
        );
      } else if (
        props.history.location.pathname.includes(
          "/brands-and-campaigns/brands/"
        )
      ) {
        let brandName = props?.history?.location?.state?.brand?.name || "";
        settile(`${brandName} Brand Campaign`);
      } else if (
        props.history.location.pathname.includes(
          "/brands-and-campaigns/campaigns/"
        )
      ) {
        let campaignName =
          props?.history?.location?.state?.campaign?.name || "";
        settile(`${campaignName}`);
      } else if (props.history.location.pathname == "/quotations") {
        settile("NoBrokerHood Quotations");
      } else if (props.history.location.pathname.includes("/templates")) {
        settile("NoBrokerHood Templates");
      } else if (props.history.location.pathname == "/geolocation") {
        settile("NoBrokerHood Geo Location");
      } else if (props.history.location.pathname == "/call-history") {
        settile(
          label?.CALL_HISTORY_HEADER
            ? label?.CALL_HISTORY_HEADER
            : "CALL_HISTORY_HEADER"
        );
      } else if (props.history.location.pathname == "/inventory") {
        settile(
          label?.INVENTORY_HEADER ? label?.INVENTORY_HEADER : "INVENTORY_HEADER"
        );
      } else if (props.history.location.pathname == "/audit") {
        settile(label?.AUDIT_HEADER ? label?.AUDIT_HEADER : "AUDIT_HEADER");
      } else if (props.history.location.pathname == "/tickets") {
        settile(
          label?.MANAGE_TICKET_HEADER
            ? label?.MANAGE_TICKET_HEADER
            : "MANAGE_TICKET_HEADER "
        );
      } else if (props.history.location.pathname == "/service-loan") {
        settile(
          label?.SERVICE_LOAN_HEADER
            ? label?.SERVICE_LOAN_HEADER
            : "SERVICE_LOAN_HEADER"
        );
      } else if (props.history.location.pathname == "/mydocument") {
        settile(
          label?.DOCUMENTS_HEADER ? label?.DOCUMENTS_HEADER : "DOCUMENTS_HEADER"
        );
      } else if (props.history.location.pathname == "/my-approval") {
        settile(
          label?.MY_APPROVAL_HEADER
            ? label?.MY_APPROVAL_HEADER
            : "MY_APPROVAL_HEADER"
        );
      } else if (props.history.location.pathname == "/assign-filters") {
        settile(
          label?.RESOURCE_POOL_MANAGEMENT_HEADER
            ? label?.RESOURCE_POOL_MANAGEMENT_HEADER
            : "RESOURCE_POOL_MANAGEMENT_HEADER"
        );
      } else if (props.history.location.pathname == "/label-management") {
        settile(
          label?.LABEL_MANAGEMENT_HEADER
            ? label?.LABEL_MANAGEMENT_HEADER
            : "LABEL_MANAGEMENT_HEADER"
        );
      } else if (props.history.location.pathname == "/admin-workflow") {
        settile(
          label.WORKFLOW_AUTOMATION_HEADER
            ? label.WORKFLOW_AUTOMATION_HEADER
            : "WORKFLOW_AUTOMATION_HEADER"
        );
      } else if (props.history.location.pathname == "/accounts") {
        settile(
          label.LEAD_ACCOUNT_HEADER
            ? label.LEAD_ACCOUNT_HEADER
            : "LEAD_ACCOUNT_HEADER"
        );
      } else if (props.history.location.pathname == "/settings") {
        settile(
          label.SETTINGS_HEADER ? label.SETTINGS_HEADER : "SETTINGS_HEADER"
        );
      } else if (
        props.history.location.pathname?.includes("/product-advisor")
      ) {
        settile("Product advisor");
      } else if (props.history.location.pathname?.includes("/integration")) {
        settile("Integrations");
      } else if (
        props.history.location.pathname?.includes("/status-transition")
      ) {
        settile("Status Modifier");
      } else if (props.history.location.pathname?.includes("/manage-bre")) {
        settile("Manage BRE");
      } else if (props.history.location.pathname?.includes("/my-dashboard")) {
        settile("My Dashboard");
      } else if (props.history.location.pathname?.includes("/social-tickets")) {
        settile("Social Tickets");
      } else if (props.history.location.pathname?.includes("/partner")) {
        settile("Partners");
      } else if (props.history.location.pathname == "/incentive") {
        settile("Incentive");
      } else if (props.history.location.pathname == "/rewards") {
        settile("Rewards");
      } else if (props.history.location.pathname == "/lead-events") {
        settile("Lead Events");
      } else if (props.history.location.pathname == "/reward-gen") {
        settile("Incentive Management");
      } else if (props.history.location.pathname == "/social-customer") {
        settile("Customer 360");
      } else if (props.history.location.pathname == "/dashboard-lock") {
        settile("Dashboard locked");
      } else {
        settile(
          label?.RESOURCE_HIERARCHY_HEADER
            ? label?.RESOURCE_HIERARCHY_HEADER
            : "RESOURCE_HIERARCHY_HEADER"
        );
      }
    }
  });
  useEffect(() => {
    if (!props.notificationCount && !props.login) {
      getNotificationCountData();
    }
    fetchPendingItemCall();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [props?.univiewConfig?.showSlashRTC]);

  useEffect(() => {
    const jsonObj = {
      phoneNumber: incomingNumber,
    };
    if (incomingNumber) getOnCallLeadFn(jsonObj);
  }, [incomingNumber]);
  const escFunction = (event) => {
    if (event.key === "Escape") {
      update({ showSlashRTC: !props?.univiewConfig?.showSlashRTC });
      document.removeEventListener("keydown", escFunction, false);
    }
  };
  const showToast = (toast) => {
    toastRef.current.addToast({
      type: toast.type,
      message: toast.message,
    });
  };
  const getProfile = async () => {
    const result = await getUserProfile();
    if (result.status === 1 && result.data && result.data.id) {
      props.update({
        profile: result.data,
      });
    }
  };
  const integraionDetails = async (type) => {
    const result = await getIntegrationDetails(type);

    if (result?.status === 1) {
      props?.update &&
        props?.update({
          virtualCallData: result.data?.[0],
        });
    }
  };

  const handlePunchInOut = async (text = "", cb, byPass = "") => {
    setloading(true);
    const data =
      byPass !== undefined && byPass !== null ? { byPass: byPass } : "";
    const result = await postPunchInOut(text, data);
    if (result.status === 1) {
      attendance = result.data;
      getProfile();
      setloading(false);
      cb && cb();
      showToast({
        type: "success",
        message: result.message
          ? result.message
          : `${
              text === "punch-out" ? `Punched-Out` : `Punched-In`
            } Successfully `,
      });
      workLogAutoOpen && workLogModal();
    } else {
      setloading(false);
      showToast({
        type: "error",
        message: result.errorDescription
          ? result.errorDescription
          : "Something Went Wrong ",
      });
    }
  };
  const getNotificationCountData = async () => {
    const result = await getNotificationCount();
    if (result.status === 1) {
      props.update({
        notificationCount: result.data,
      });
    }
  };
  const notificationModal = (modal) => (
    <ModalRightPanel width={"400px"}>
      <NotificationContainer
        closeModal={modal.closeModal}
        showToast={showToast}
      />
    </ModalRightPanel>
  );
  const handleSlashRTC = () => {
    if (props?.univiewConfig?.slashRtcData?.userActive) {
      update({ startSlashRTC: true, showSlashRTC: true });
    }
  };
  const SlashRTCData = async () => {
    const rtcData = await slashRtc();
    if (rtcData?.status === 1) {
      update({
        slashRtcData: rtcData?.data,
      });
    }
  };
  useEffect(() => {
    SlashRTCData();
    integraionDetails("VirtualMeet");
  }, []);

  const update = (data) => {
    const univiewConfig = { ...props?.univiewConfig, ...data };
    props?.update &&
      props?.update({
        univiewConfig: univiewConfig,
      });
  };

  const onCallLeadSearchModal = (data, hideTimer = false) => (
    <ModalPanel>
      <ModalControl>
        {(control) => (
          <LeadSearchModal
            closeModal={control.closeModal}
            data={data}
            hideTimer={hideTimer}
            getOnCallLeadFn={getOnCallLeadFn}
          />
        )}
      </ModalControl>
    </ModalPanel>
  );

  const workLogModal = () => {
    props.openModal(
      <ModalPanel width="80%">
        <ModalControl>
          {(control) => (
            <WorkLog
              closeModal={control.closeModal}
              showToast={showToast}
              setloading={setloading}
            />
          )}
        </ModalControl>
      </ModalPanel>
    );
  };

  return (
    <React.Fragment>
      {props.login ? (
        <header styleName="base-login-page">
          <div styleName="logo"></div>
        </header>
      ) : (
        <div styleName={props.fullNavWindow ? "base-full-nav" : "base"}>
          <div styleName="title">
            {props.history.location.pathname === "/home" ||
            !props.universalLabels
              ? "Welcome to Univw"
              : title}
            <div styleName="navbar-container">
              {!isDashboardLocked &&
                navList?.map(
                  (val) =>
                    val && (
                      <div
                        key={val.label}
                        style={{
                          cursor: isDashboardLocked ? "not-allowed" : "",
                        }}
                        styleName={`nav-list${val.active ? "-active" : ""}`}
                        onClick={() => {
                          !val.active && props.history.push(val.path);
                        }}>
                        {val.label}
                        {val?.count ? (
                          <div styleName="items-count">{val?.count}</div>
                        ) : null}
                      </div>
                    )
                )}
            </div>
          </div>
          <div styleName="content">
            {props?.univiewConfig?.slashRtcData?.active && (
              <span
                styleName="calling"
                style={{
                  opacity: props?.univiewConfig?.slashRtcData?.userActive
                    ? "1"
                    : "0.5",
                  cursor: props?.univiewConfig?.slashRtcData?.userActive
                    ? "pointer"
                    : "not-allowed",
                }}
                title={props?.univiewConfig?.slashRtcData?.message}
                onClick={handleSlashRTC}></span>
            )}
            {showIncomingCallFilter && (
              <div
                styleName="lead-search"
                title="Search Incoming Lead"
                onClick={() =>
                  props.openModal(onCallLeadSearchModal(null, true))
                }
              />
            )}
            {props?.univiewConfig?.startSlashRTC && (
              <Draggable
                visibility={
                  props?.univiewConfig?.showSlashRTC ? "visible" : "hidden"
                }
                position={{ top: "55vh", left: "80%" }}>
                <div styleName="slash-rtc-base">
                  <div styleName="header">
                    <div styleName="header-text">Slash RTC</div>
                    <div
                      styleName="minus-icon"
                      onClick={() => update({ showSlashRTC: false })}
                      title="Minimize"
                    />
                    <div
                      styleName="cross-icon"
                      onClick={() => update({ startSlashRTC: false })}
                      title="Close"
                    />
                  </div>
                  <iframe
                    width="350px"
                    height="500px"
                    src={props?.univiewConfig?.slashRtcData?.url}
                    allow="camera *; microphone *;"></iframe>
                </div>
              </Draggable>
            )}
            {props.profile?.resource?.isDashboardLocked && (
              <div
                title="Dashboard lock page"
                styleName="lock-icon"
                onClick={() => {
                  props.history.push("/dashboard-lock");
                }}></div>
            )}
            {props.history.location.pathname !== "/home" && (
              <ModalControl>
                {(modal) => (
                  <div
                    styleName="notification-icon"
                    style={{
                      cursor: isDashboardLocked ? "not-allowed" : "",
                    }}
                    onClick={() => {
                      if (isDashboardLocked) {
                        showToast({
                          type: "error",
                          message: "Dashboard has been locked",
                        });
                      } else {
                        modal.openModal(notificationModal(modal));
                      }
                    }}>
                    <div styleName="notification-count">
                      {props.notificationCount}
                    </div>
                  </div>
                )}
              </ModalControl>
            )}
            <div styleName="attendance-container">
              {attendance?.punchedIn ? (
                <React.Fragment>
                  <div>
                    {attendance?.punchInTime && (
                      <div styleName="punch-time">
                        Punched-In Time
                        <span style={{ marginLeft: "16px" }}>
                          {moment(attendance.punchInTime).format("hh:mm A")}
                        </span>
                      </div>
                    )}
                    {attendance?.punchOutTime && (
                      <div styleName="punch-time">
                        Punched-Out Time
                        <span style={{ marginLeft: "8px" }}>
                          {moment(attendance.punchOutTime).format("hh:mm A")}
                        </span>
                      </div>
                    )}
                  </div>
                  <Button
                    label="Punch Out "
                    color="#ff435e"
                    loading={loading}
                    onClick={() => {
                      if (isDashboardLocked) {
                        showToast({
                          type: "error",
                          message: "Dashboard has been locked",
                        });
                      } else {
                        handlePunchInOut("punch-out");
                      }
                    }}
                    fontSize={"13px"}
                    height="32px"
                    width="93px"
                    padding="0px"
                    fontWeight="600"
                    cursor={isDashboardLocked ? "not-allowed" : ""}
                  />
                </React.Fragment>
              ) : (
                <Button
                  label="Punch In"
                  loading={loading}
                  onClick={() => {
                    if (isDashboardLocked) {
                      showToast({
                        type: "error",
                        message: "Dashboard has been locked",
                      });
                    } else {
                      handlePunchInOut("punch-in", null, true);
                    }
                  }}
                  fontSize={"12px"}
                  width="93px"
                  padding="0px"
                  cursor={isDashboardLocked ? "not-allowed" : ""}
                />
              )}
              {props.history?.location?.pathname !== "/home" && (
                <ProfileContainer
                  history={props.history}
                  handlePunchInOut={handlePunchInOut}
                  showToast={showToast}
                  label={label}
                  workLogModal={workLogModal}
                  workLogAutoOpen={workLogAutoOpen}
                  isDashboardLocked={isDashboardLocked}
                />
              )}
            </div>
          </div>
        </div>
      )}
      <Toast ref={toastRef} />
    </React.Fragment>
  );
}

export default Header;
